import {
  Component,
  Input,
  input,
} from '@angular/core';
import { IService, IServiceInfo, IServiceInfoDetail } from 'src/app/models';
import { Colors } from 'src/app/models/enums';
import { UtilsService } from 'src/app/services';

import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-service-tag',
  templateUrl: './service-tag.component.html',
  imports: [CommonModule],
  styleUrl: './service-tag.component.scss',
})
export class ServiceTagComponent {
  @Input() serviceInfo: IService | IServiceInfo | IServiceInfoDetail;
  // Half-size variant for tight places such as a map info window
  readonly compact = input<boolean>(false);

  public Colors = Colors;

  constructor(public utilsService: UtilsService) {}
}
